import { getColor } from '@/utils/class-name-helper';
import { BannerTile } from '@cinemark/content-api-client';
import clsx from 'clsx';
import { BannerImageComponent } from './banner-image';
import { BannerTextComponent } from './banner-text';

type BannerTileProps = {
  bannerTile: BannerTile;
  dataLinkCategory: string;
  dataLinkNamePrefix?: string;
  imageAspectClassName?: string;
};

export const BannerTileComponent = ({
  bannerTile, dataLinkCategory, dataLinkNamePrefix, imageAspectClassName = 'aspect-video',
}: BannerTileProps): React.JSX.Element | null => {
  if (!bannerTile) return null;

  const hasImage = !!(bannerTile.bannerImageLarge?.url || bannerTile.bannerImageMedium?.url || bannerTile.bannerImageSmall?.url);
  const isImageRight = bannerTile.tileImageAlignment === 'Right';
  const bgColor = getColor(bannerTile.tileBackgroundColor);

  const displayImageOrBackground = (): React.JSX.Element => {
    if (hasImage) {
      return (
        <BannerImageComponent banner={bannerTile}
          className="absolute inset-0 w-full h-full"
        />
      );
    }

    return (
      <div className={clsx('absolute inset-0 flex items-center justify-center', bgColor)} />
    );
  };

  return (
    <div className={clsx('flex flex-col md:flex-row md:items-stretch rounded-md overflow-hidden w-full', isImageRight && 'md:flex-row-reverse')}>
      <div className={clsx('relative w-full md:w-1/2', imageAspectClassName)}>
        {displayImageOrBackground()}
      </div>
      <BannerTextComponent banner={bannerTile}
        className="w-full md:w-1/2"
        dataLinkCategory={dataLinkCategory}
        dataLinkNamePrefix={dataLinkNamePrefix}
      />
    </div>
  );
};
